import { TrackerItem } from "@/v2/entities/tracker/Tracker.model";

export const mockTrackerItem: TrackerItem = {
  id: "preview-item",
  stage: "to_do" as const,
  columnId: "COLUMN-123",
  ticketId: "TICKET-123",
  conversationId: null,
  interactionData: {
    interactionType: "tickets",
    id: "TICKET-123",
    displayId: "TICKET-123",
    subject: "Customer inquiry about product features",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    status: "open",
    channel: "email",
    topic: "Integrations",
    subTopic: "Integration to Quack",
    category: "General Request",
    agentAssigned: "John Doe",
    team: [{ name: "support", externalId: "support" }],
    avgQaScore: 4.5,
    avgSentiment: 0.8,
    csat: 5,
    countPublicMessages: 3,
    countInternalMessages: 1,
    timeToResolution: 3600,
    timeToFirstResponse: 300,
    resolutionStatus: "RESOLVED",
    escalationReason: "USER_REQUESTED",
    skipReason: "NO_RELEASE_FOUND",
    resolvedReason: "FULLY_RESOLVED",
    countQuackMessages: 2,
    collaborators: [
      {
        agentId: 1,
        agentName: "Jane Smith",
        avgQaScore: 4.5,
        publicCommentsCount: 1,
        internalCommentsCount: 0,
      },
    ],
    isQuackEscalated: false,
    isFiniteState: true,
  },
  comment: "",
  events: [],
};
